/* サムネイルはメイン画像を差し替えず、拡大モーダルで開く(2026-08-20)
   参考: afuribrewing.com のサブ画像の挙動。

   Dawnはサムネイルのbuttonへ直接クリックリスナーを張り、メイン画像を
   切り替える(media-gallery.js の setActiveMedia)。ここではdocumentの
   キャプチャ段階で先回りして伝播を止め、代わりに商品メディアモーダル
   (product-modal)を開く。モーダル側はopenerのdata-media-idを見て
   該当メディアまでスクロールする。 */

(() => {
  const SECTION_PREFIX = 'MediaGallery-';

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      // 購入ボタン下の一覧(ny-soda-product-thumbnails)
      const ownButton = target.closest('.ny-soda-thumbs__button[data-media-id]');
      if (ownButton) {
        const wrap = ownButton.closest('.ny-soda-thumbs');
        const ownModal = wrap && document.querySelector(wrap.dataset.modal);
        if (ownModal && typeof ownModal.show === 'function') {
          event.preventDefault();
          event.stopPropagation();
          ownModal.show(ownButton);
        }
        return;
      }

      const item = target.closest('.thumbnail-list__item[data-target]');
      if (!item) return;

      const gallery = item.closest('media-gallery');
      if (!gallery || !gallery.id.startsWith(SECTION_PREFIX)) return;

      const sectionId = gallery.id.slice(SECTION_PREFIX.length);
      const modal = document.querySelector(`#ProductModal-${sectionId}`);
      if (!modal || typeof modal.show !== 'function') return;

      const mediaId = item.dataset.target.replace(`${sectionId}-`, '');
      if (!modal.querySelector(`[data-media-id="${mediaId}"]`)) return;

      const opener = item.querySelector('button') || item;
      // ProductModalはopenerのdata-media-idで開くメディアを決める
      opener.setAttribute('data-media-id', mediaId);

      // Dawnの「メイン画像を差し替える」リスナーへ届く前に止める
      event.preventDefault();
      event.stopPropagation();
      modal.show(opener);
    },
    true
  );
})();

/* 拡大モーダルの前後移動とSPの外側タップで閉じる(2026-10-16)

   - 矢印(snippets/product-media-modal.liquid の [data-modal-nav])・左右キー・
     SPの横スワイプで、拡大したまま前後の画像へ移る(最後の次は最初へ戻る)
   - Dawnはマウスのときだけ画面のどこを押しても閉じる(global.js の ModalDialog)。
     タッチでも画像の外を押したら閉じるようにする。画像の上・矢印・閉じるボタンでは閉じない
   - Dawnはバリアント変更でモーダルの中身を差し替えるため、画像の一覧は毎回取り直す */

(() => {
  const NAV = '[data-modal-nav]';
  const KEEP_OPEN = 'img, deferred-media, product-model, .product-media-modal__model, .product-media-modal__toggle, ' + NAV;

  const itemsOf = (modal) => {
    const content = modal.querySelector('.product-media-modal__content');
    if (!content) return [];
    return Array.from(content.children).filter(
      (el) => el.matches('[data-media-id]') && !el.classList.contains('product__media-item--variant')
    );
  };

  const syncNav = (modal) => {
    const single = itemsOf(modal).length < 2;
    modal.querySelectorAll(NAV).forEach((button) => {
      button.hidden = single;
    });
  };

  const go = (modal, step) => {
    const items = itemsOf(modal);
    if (items.length < 2) return;
    const current = Math.max(
      0,
      items.findIndex((el) => el.classList.contains('active'))
    );
    const next = items[(current + step + items.length) % items.length];
    items.forEach((el) => el.classList.toggle('active', el === next));
    if (typeof next.loadContent === 'function' && next.querySelector('template')) next.loadContent();
  };

  const setup = (modal) => {
    if (modal.dataset.nySodaNav) return;
    modal.dataset.nySodaNav = 'true';

    modal.querySelectorAll(NAV).forEach((button) => {
      // Dawnはマウスのpointerupでモーダルを閉じるため、矢印の上では止める
      button.addEventListener('pointerup', (event) => event.stopPropagation());
      button.addEventListener('click', (event) => {
        event.preventDefault();
        go(modal, Number(button.dataset.modalNav));
      });
    });

    modal.addEventListener('keydown', (event) => {
      if (!modal.hasAttribute('open')) return;
      if (event.key === 'ArrowLeft') go(modal, -1);
      if (event.key === 'ArrowRight') go(modal, 1);
    });

    // タッチ: 横スワイプで前後へ、動かさずに画像の外を押したら閉じる。
    // pointer系は横に指を動かすとブラウザがスクロールとして引き取り pointercancel になるため、
    // touch系で判定する。閉じるときは touchend で既定動作を止め、指を離した位置に
    // 続けて届くクリック(閉じた後ろのボタン等)が押されないようにする
    let start = null;
    modal.addEventListener(
      'touchstart',
      (event) => {
        if (!modal.hasAttribute('open') || event.touches.length !== 1) return;
        start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      },
      { passive: true }
    );
    modal.addEventListener(
      'touchend',
      (event) => {
        if (!start || !modal.hasAttribute('open')) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - start.x;
        const dy = touch.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          go(modal, dx < 0 ? 1 : -1);
          return;
        }
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10 && !event.target.closest(KEEP_OPEN)) {
          event.preventDefault();
          modal.hide();
        }
      },
      { passive: false }
    );
    modal.addEventListener('touchcancel', () => {
      start = null;
    });

    // 開くたび(=open属性が付くたび)に矢印の要否を見直す
    new MutationObserver(() => {
      if (modal.hasAttribute('open')) syncNav(modal);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    syncNav(modal);
  };

  const init = () => document.querySelectorAll('product-modal.media-modal').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
